import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../css/style.css';

import wedding from '../images/wedding.jpg';
import engagement from '../images/engaement.jpg'; // Note: Fix typo in filename if needed (engaement -> engagement)
import reception from '../images/reception.jpg';
import birthday from '../images/birthday.jpg';
import anniversary from '../images/anniversary.jpg';
import corporate from '../images/corporate.jpg';
import socialevt from '../images/social.jpg';

const events = [
  {
    title: 'Weddings',
    description: 'Celebrate your special day with our bespoke wedding planning services, tailored to create unforgettable moments.',
    image: wedding,
    alt: 'Weddings',
  },
  {
    title: 'Engagements',
    description: 'Mark the beginning of your journey together with a beautifully curated engagement event.',
    image: engagement,
    alt: 'Engagements',
  },
  {
    title: 'Receptions',
    description: 'Host an elegant reception with our expert planning and stunning decor options.',
    image: reception,
    alt: 'Receptions',
  },
  {
    title: 'Birthdays',
    description: 'Make every birthday memorable with our fun and personalized party planning services.',
    image: birthday,
    alt: 'Birthdays',
  },
  {
    title: 'Anniversaries',
    description: 'Celebrate your milestones with our heartfelt and customized anniversary events.',
    image: anniversary,
    alt: 'Anniversaries',
  },
  {
    title: 'Corporate Meetings',
    description: 'Elevate your business events with our professional and seamless corporate meeting solutions.',
    image: corporate,
    alt: 'Corporate Meetings',
  },
  {
    title: 'Social Events',
    description: 'Bring people together with our vibrant and engaging social event planning services.',
    image: socialevt,
    alt: 'Social Events',
  },
];

const EventCard = ({ title, description, image, alt }) => (
  <div className="col-md-4 col-sm-6">
    <div className="event-card">
      <img
        src={image}
        alt={alt}
        className="card-img-top"
        onError={(e) => (e.target.src = 'https://via.placeholder.com/500x200?text=Image+Not+Found')}
      />
      <div className="card-body">
        <h3 className="card-title">{title}</h3>
        <p className="card-text">{description}</p>
        <a href="#" className="btn btn-custom">
          Learn More
        </a>
      </div>
    </div>
  </div>
);

const Service = () => {
  return (
    <div>
      <section className="event-section">
        <div className="container">
          <h2 className="text-center section-title">Our Event Services</h2>
          <div className="row g-4">
            {events.map((event, index) => (
              <EventCard
                key={index}
                title={event.title}
                description={event.description}
                image={event.image}
                alt={event.alt}
              />
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Service;